<template>
  <SimpleCrud
    :headers="headers"
    :name="rq_name"
    :canWrite="false"
    :canDetail="false"
    :canAdd="false"
    :canDelete="false">
    <template v-slot:creation_date="{ value }">
      <td>{{formalDateFormat(value)}}</td>
    </template>
    <template slot="filters">
      <div class="form-v1">
      <v-layout>
        <debounce-select md="3" :name="rq_name" :value.sync="filter.s__action" item_key="action" label="Acción" append_icon="search"/>
        <calendar-rq md="3" :name="rq_name" :value.sync="filter.d__creation_date__gte" item_key="creation_date" pre_f="gte" label="Fecha inicio" append_icon="search"/>
        
        <v-flex md6 style="text-align: end;">
          <refresh-rq :name="rq_name"/>
          <export-ex :ex_permission="17" :name="rq_name" custom_name="export/tracking"/>
        </v-flex>
      </v-layout>
      </div>
    </template>
    <template slot="crud-title"></template>
  </SimpleCrud>
</template>

<script>
import { formalDateFormat } from '@/functions/general.js';
import filter from '@/components/mixins/filter';
export default {
  mixins:[filter],
  data() {
    return {
      rq_name:'track_activitie',
      headers:[
				{ text: 'Fecha', sortable: true, value: 'creation_date' },
				{ text: 'Nombre', sortable: true, value: 'onwer_full_name' },
				{ text: 'Acción', sortable: true, value: 'action' },
				{ text: 'BCEI', sortable: true, value: 'critical_asset_name' },
				{ text: 'Repuesto', sortable: true, value: 'spare_part_name' },
      ],
    };
  },
  methods:{
    formalDateFormat,
  }
};
</script>